/* =====================================================================
   17 NUTRITION – REVIEWS UIT JUDGE.ME (07-10-2026)
   Reviews via de Judge.me widget-API (PUBLIEKE sleutel). Reviews in een
   andere taal dan de pagina worden vertaald via de vertaaldienst van
   Judge.me (zelfde als de standaard widgets), met label "Vertaald" en
   knop "Toon origineel". Lukt vertalen niet: alleen reviews in de eigen taal.
   - carousel: homepage, winkelreviews, >= min. sterren, min. lengte, max.
     Geen resultaat = sectie weg.
   - list: reviewpagina, tabbladen winkel/producten, alle sterren, "Meer laden".
   Tekst wordt als tekst gezet (nooit als HTML). 30 min cache per sessie
   (sleutel n17-rv2/n17-tr2; ophogen als de opbouw van de cache wijzigt).
   ===================================================================== */
(function () {
  if (window.N17Reviews) return;
  window.N17Reviews = true;

  var T = {
    nl: { v: 'Geverifieerde koper', d0: 'vandaag', d1: 'gisteren', dn: '{n} dagen geleden', w1: '1 week geleden', wn: '{n} weken geleden', m1: '1 maand geleden', mn: '{n} maanden geleden', y: 'meer dan een jaar geleden', more: 'Meer beoordelingen laden', stars: '{n} van 5 sterren', about: 'over', tr: 'Vertaald', orig: 'Toon origineel', back: 'Toon vertaling' },
    en: { v: 'Verified buyer', d0: 'today', d1: 'yesterday', dn: '{n} days ago', w1: '1 week ago', wn: '{n} weeks ago', m1: '1 month ago', mn: '{n} months ago', y: 'over a year ago', more: 'Load more reviews', stars: '{n} out of 5 stars', about: 'about', tr: 'Translated', orig: 'Show original', back: 'Show translation' },
    de: { v: 'Verifizierter Käufer', d0: 'heute', d1: 'gestern', dn: 'vor {n} Tagen', w1: 'vor 1 Woche', wn: 'vor {n} Wochen', m1: 'vor 1 Monat', mn: 'vor {n} Monaten', y: 'vor über einem Jahr', more: 'Weitere Bewertungen laden', stars: '{n} von 5 Sternen', about: 'zu', tr: 'Übersetzt', orig: 'Original anzeigen', back: 'Übersetzung anzeigen' },
    da: { v: 'Verificeret køber', d0: 'i dag', d1: 'i går', dn: '{n} dage siden', w1: '1 uge siden', wn: '{n} uger siden', m1: '1 måned siden', mn: '{n} måneder siden', y: 'over et år siden', more: 'Indlæs flere anmeldelser', stars: '{n} ud af 5 stjerner', about: 'om', tr: 'Oversat', orig: 'Vis original', back: 'Vis oversættelse' }
  };
  var WORDS = {
    nl: ['de', 'het', 'een', 'en', 'goed', 'goede', 'goeie', 'snel', 'snelle', 'prijs', 'top', 'heel', 'zeer', 'niet', 'echt', 'aanrader', 'kwaliteit', 'producten', 'spul', 'bezorgd', 'altijd', 'tevreden', 'lekker', 'ik', 'voor', 'van', 'wel', 'maar', 'binnen', 'betrouwbaar'],
    en: ['the', 'and', 'good', 'great', 'fast', 'price', 'quality', 'very', 'best', 'product', 'products', 'service', 'recommend', 'really', 'excellent', 'amazing', 'i', 'is', 'it', 'for'],
    de: ['und', 'schnell', 'schnelle', 'sehr', 'lieferung', 'gut', 'preis', 'ich', 'ist', 'empfehle', 'produkt', 'qualität', 'alles', 'super', 'danke', 'war'],
    da: ['og', 'hurtig', 'god', 'meget', 'pris', 'kvalitet', 'produkter', 'smager', 'det', 'jeg', 'tak', 'fantastisk']
  };

  function langOf(text) {
    var w = (text.toLowerCase().match(/[a-zà-ÿæøåß]+/g) || []);
    var best = '', bestScore = 0;
    Object.keys(WORDS).forEach(function (l) {
      var s = 0;
      w.forEach(function (x) { if (WORDS[l].indexOf(x) !== -1) s++; });
      if (s > bestScore) { best = l; bestScore = s; }
    });
    return best;
  }

  // Kalenderdagen in de tijdzone van de bezoeker
  function rel(dateStr, t) {
    var d = new Date(dateStr.replace(' UTC', 'Z').replace(' ', 'T'));
    if (isNaN(d)) return '';
    var a = new Date(); a.setHours(0, 0, 0, 0);
    var b = new Date(d.getTime()); b.setHours(0, 0, 0, 0);
    var days = Math.round((a.getTime() - b.getTime()) / 86400000);
    if (days <= 0) return t.d0;
    if (days === 1) return t.d1;
    if (days < 7) return t.dn.replace('{n}', days);
    if (days < 14) return t.w1;
    if (days < 30) return t.wn.replace('{n}', Math.floor(days / 7));
    if (days < 60) return t.m1;
    if (days < 365) return t.mn.replace('{n}', Math.floor(days / 30));
    return t.y;
  }

  function cached(key, make) {
    try {
      var c = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (c && Date.now() - c.t < 30 * 60 * 1000) return Promise.resolve(c.r);
    } catch (e) {}
    return make().then(function (r) {
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), r: r })); } catch (e) {}
      return r;
    });
  }

  function api(cfg, type, page, perPage) {
    var url = 'https://judge.me/api/v1/widgets/all_reviews_page?shop_domain=' + encodeURIComponent(cfg.shop) +
      '&api_token=' + encodeURIComponent(cfg.token) + '&review_type=' + type +
      '&sort_by=created_at&sort_dir=desc&page=' + page + '&per_page=' + perPage;
    return cached('n17-rv2-' + type + '-' + page + '-' + perPage, function () {
      return fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) { return parse(j && j.all_reviews); });
    });
  }

  // Vertaalt reviews die niet in de paginataal staan (Judge.me review_translations)
  function translate(cfg, list) {
    var need = list.filter(function (r) { return r.id && r.lang !== cfg.locale; });
    if (!need.length) { list.forEach(function (r) { if (r.lang === cfg.locale) r.ok = true; }); return Promise.resolve(list); }
    var ids = need.map(function (r) { return r.id; });
    return cached('n17-tr2-' + cfg.locale + '-' + ids.join(',').slice(0, 300), function () {
      var url = 'https://api.judge.me/api/review_translations?review_uuids=' + ids.join(',') +
        '&shop_domain=' + encodeURIComponent(cfg.shop) + '&language=' + cfg.locale + '&page=-1';
      return fetch(url).then(function (r) { return r.ok ? r.json() : {}; }).then(function (j) {
        var out = {};
        ids.forEach(function (id) {
          var b = j && j[id] && j[id].body;
          if (b && b.success && b.translated_text) out[id] = b.translated_text;
        });
        return out;
      });
    }).then(function (map) {
      list.forEach(function (r) {
        if (r.lang === cfg.locale) { r.ok = true; return; }
        var tx = map[r.id];
        if (tx) {
          var plain = tx.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '').replace(/&amp;/g, '&').replace(/&#39;|&apos;/g, "'").replace(/&quot;/g, '"').trim();
          if (plain && plain.toLowerCase() !== r.text.toLowerCase()) { r.original = r.text; r.text = plain; r.translated = true; }
          r.ok = true;
        }
      });
      return list;
    }).catch(function () {
      list.forEach(function (r) { if (r.lang === cfg.locale) r.ok = true; });
      return list;
    });
  }

  function parse(html) {
    if (!html) return [];
    var box = document.createElement('div');
    box.innerHTML = html.replace(/<img[^>]*>/g, '');
    return Array.prototype.map.call(box.querySelectorAll('.jdgm-rev'), function (el) {
      var body = el.querySelector('.jdgm-rev__body');
      var text = '';
      if (body) {
        Array.prototype.forEach.call(body.querySelectorAll('br'), function (b) { b.replaceWith('\n'); });
        text = Array.prototype.map.call(body.querySelectorAll('p'), function (p) { return p.textContent.trim(); }).join('\n') || body.textContent.trim();
      }
      text = text.replace(/\n{3,}/g, '\n\n');
      var prod = el.querySelector('.jdgm-rev__prod-link, .jdgm-rev__prod-title');
      var ts = el.querySelector('.jdgm-rev__timestamp');
      var sc = el.querySelector('.jdgm-rev__rating');
      var au = el.querySelector('.jdgm-rev__author');
      return {
        id: el.getAttribute('data-review-id') || '',
        lang: (el.getAttribute('data-review-language') || '').split('-')[0] || langOf(text),
        name: au ? au.textContent.trim() : '',
        score: sc ? parseInt(sc.getAttribute('data-score'), 10) || 0 : 0,
        date: ts ? ts.getAttribute('data-content') || '' : '',
        text: text,
        verified: el.getAttribute('data-verified-buyer') === 'true',
        product: prod ? prod.textContent.trim() : '',
        productUrl: prod && prod.getAttribute('href') && prod.getAttribute('href').charAt(0) === '/' ? prod.getAttribute('href') : ''
      };
    });
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function stars(n, t) {
    var s = el('span', 'n17-stars');
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', t.stars.replace('{n}', n));
    for (var i = 1; i <= 5; i++) {
      var star = el('span', 'n17-star');
      var f = el('span', 'n17-star__fill');
      f.style.width = (i <= n ? 100 : 0) + '%';
      star.appendChild(f);
      s.appendChild(star);
    }
    return s;
  }

  function card(r, t, opts) {
    var a = el('article', 'n17-rcard' + (opts.clamp ? ' n17-rcard--clamp' : ''));
    a.appendChild(stars(r.score, t));
    var p = el('p', 'n17-rcard__text', r.text);
    a.appendChild(p);
    if (r.translated) {
      var tr = el('div', 'n17-rcard__tr', t.tr + ' · ');
      var b = el('button', 'n17-rcard__tr-btn', t.orig);
      b.type = 'button';
      var showOrig = false;
      b.addEventListener('click', function () {
        showOrig = !showOrig;
        p.textContent = showOrig ? r.original : r.text;
        b.textContent = showOrig ? t.back : t.orig;
      });
      tr.appendChild(b);
      a.appendChild(tr);
    }
    if (opts.product && r.product) {
      var pr = el('div', 'n17-rcard__product', t.about + ' ');
      if (r.productUrl) { var l = el('a', '', r.product); l.href = r.productUrl; pr.appendChild(l); } else pr.appendChild(document.createTextNode(r.product));
      a.appendChild(pr);
    }
    var f = el('div', 'n17-rcard__foot');
    f.appendChild(el('div', 'n17-rcard__name', r.name));
    var row = el('div', 'n17-rcard__row');
    if (r.verified) {
      var v = el('span', 'n17-rcard__verified');
      v.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"></path></svg>';
      v.appendChild(document.createTextNode(t.v));
      row.appendChild(v);
    }
    row.appendChild(el('span', 'n17-rcard__date', rel(r.date, t)));
    f.appendChild(row);
    a.appendChild(f);
    return a;
  }

  function carousel(root, cfg, t) {
    var track = root.querySelector('[data-n17-track]');
    var section = root.closest('[data-n17-section]') || root;
    api(cfg, 'shop-reviews', 1, 50).then(function (list) {
      var cand = list.filter(function (r) { return r.score >= cfg.min && r.text.length >= cfg.minLength; }).slice(0, cfg.max + 6);
      return translate(cfg, cand);
    }).then(function (cand) {
      var picked = cand.filter(function (r) { return r.ok; }).slice(0, cfg.max);
      if (!picked.length) { section.hidden = true; return; }
      track.textContent = '';
      picked.forEach(function (r) { track.appendChild(card(r, t, { clamp: true })); });
      root.classList.add('is-ready');
    }).catch(function () { section.hidden = true; });

    Array.prototype.forEach.call(root.querySelectorAll('[data-n17-dir]'), function (b) {
      b.addEventListener('click', function () {
        var c = track.querySelector('.n17-rcard');
        var step = c ? c.getBoundingClientRect().width + 16 : 300;
        track.scrollBy({ left: step * parseInt(b.getAttribute('data-n17-dir'), 10), behavior: 'smooth' });
      });
    });
  }

  function list(root, cfg, t) {
    var out = root.querySelector('[data-n17-list]');
    var more = root.querySelector('[data-n17-more]');
    var tabs = root.querySelectorAll('[data-n17-tab]');
    var state = { type: 'shop-reviews', page: 0, run: 0 };
    more.textContent = t.more;

    function load() {
      state.page++;
      var run = state.run;
      more.disabled = true;
      api(cfg, state.type, state.page, 20).then(function (items) {
        return translate(cfg, items).then(function (tr) { return { items: tr, n: items.length }; });
      }).then(function (res) {
        if (run !== state.run) return;
        res.items.forEach(function (r) { out.appendChild(card(r, t, { product: state.type !== 'shop-reviews' })); });
        more.disabled = false;
        more.hidden = res.n < 20;
      }).catch(function () { more.hidden = true; });
    }

    Array.prototype.forEach.call(tabs, function (b) {
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(tabs, function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        state.type = b.getAttribute('data-n17-tab');
        state.page = 0;
        state.run++;
        out.textContent = '';
        load();
      });
    });
    more.addEventListener('click', load);
    load();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-n17-reviews]:not(.is-init)'), function (root) {
      root.classList.add('is-init');
      var d = root.dataset;
      var locale = (d.locale || 'nl').split('-')[0];
      if (!T[locale]) locale = 'nl';
      var t = T[locale];
      var cfg = { shop: d.shop, token: d.token, locale: locale, max: parseInt(d.max || '8', 10), min: parseInt(d.min || '4', 10), minLength: parseInt(d.minLength || '20', 10) };
      if (!cfg.shop || !cfg.token) { (root.closest('[data-n17-section]') || root).hidden = d.mode !== 'list'; return; }
      if (d.mode === 'list') list(root, cfg, t); else carousel(root, cfg, t);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();